/// <reference types="vite/client" />
// frontend/src/config/paths.ts
// Версия: 2.2.0 - Убран trailing slash из BASE_PATH (исключаем /ssas//api)
// Дата: 2026-01-16
// ИСПРАВЛЕНО: Добавлен алиас api = apiUrl для обратной совместимости (сохранено)

/**
 * Базовый путь приложения (из env или пустая строка для локалки)
 * DEV: '' → все пути от корня (/)
 * PROD: '/ssas' → все пути с префиксом (/ssas/)
 *
 * ВАЖНО: trailing slash удаляется автоматически, чтобы не получалось '/ssas//api'.
 */
const rawBasePath: string = import.meta.env.VITE_BASE_PATH || '';
export const BASE_PATH: string =
  rawBasePath === '/' ? '' : rawBasePath.endsWith('/') ? rawBasePath.slice(0, -1) : rawBasePath;

/**
 * Полный базовый URL для API
 * DEV: '/api'
 * PROD: '/ssas/api'
 */
export const API_BASE_URL: string = `${BASE_PATH}/api`;

/**
 * Хелпер для построения API URL
 * @param path - путь без начального слэша (например, 'auth/login')
 * @returns полный API URL (например, '/api/auth/login' или '/ssas/api/auth/login')
 *
 * @example
 * apiUrl('auth/login') → '/api/auth/login' (dev) или '/ssas/api/auth/login' (prod)
 * apiUrl('/auth/login') → '/api/auth/login' (ведущий слэш автоматически удаляется)
 */
export function apiUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
}

/**
 * Алиас для apiUrl — обратная совместимость с кодом, использующим api()
 * @deprecated Используйте apiUrl() вместо api()
 */
export const api = apiUrl;

/**
 * Хелпер для построения App URL (для navigate/Link/window.location.href)
 * @param path - путь приложения (например, '/operator' или 'operator')
 * @returns полный App URL (например, '/operator' или '/ssas/operator')
 *
 * @example
 * appUrl('/operator') → '/operator' (dev) или '/ssas/operator' (prod)
 * appUrl('client/requests') → '/client/requests' (dev) или '/ssas/client/requests' (prod)
 */
export function appUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_PATH}${cleanPath}`;
}

/**
 * Хелпер для построения URL статических ресурсов (images, audio, fonts)
 * @param path - путь к ресурсу (например, '/mss2018.svg' или 'sounds/alert.mp3')
 * @returns полный Asset URL
 *
 * @example
 * assetUrl('/mss2018.svg') → '/mss2018.svg' (dev) или '/ssas/mss2018.svg' (prod)
 * assetUrl('sounds/alert.mp3') → '/sounds/alert.mp3' (dev) или '/ssas/sounds/alert.mp3' (prod)
 */
export function assetUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_PATH}${cleanPath}`;
}

/**
 * Проверка, является ли путь API путем
 * @param path - путь для проверки
 * @returns true если это API путь
 */
export function isApiPath(path: string): boolean {
  return path.startsWith('/api') || path.startsWith(`${BASE_PATH}/api`);
}

/**
 * Проверка, является ли путь Training API путем
 * @param path - путь для проверки
 * @returns true если это Training API путь
 */
export function isTrainingApiPath(path: string): boolean {
  return path.includes('/api/training') || path.includes(`${BASE_PATH}/api/training`);
}
